import { Message } from '@gonfalon/messages/Message';
import { msg } from '@gonfalon/messages/msg';
import { Dialog, Heading, IconButton, Modal, ModalOverlay, type ModalOverlayProps } from '@launchpad-ui/components';

import { FeedbackForm } from './internal/FeedbackForm';

import styles from './ContextualFeedbackTrigger.module.css';

export type ContextualFeedbackModalProps = {
  /** Recipient flag key. Feedback is submitted to the qualitative feedback product via the SDK and tied to this flag. */
  flagKey: string;
} & ModalOverlayProps;

export function ContextualFeedbackModal({ flagKey, ...props }: ContextualFeedbackModalProps) {
  return (
    <ModalOverlay {...props}>
      <Modal size="small">
        <Dialog aria-label={msg('feedback.contextualDialog.heading')}>
          {({ close }) => (
            <>
              <div className={styles.modalHeader}>
                <Heading slot="title">
                  <Message id="feedback.contextualDialog.heading" />
                </Heading>
                <IconButton
                  aria-label={msg('feedback.contextualDialog.closeLabel')}
                  icon="cancel"
                  variant="minimal"
                  onPress={close}
                />
              </div>
              <FeedbackForm flagKey={flagKey} />
            </>
          )}
        </Dialog>
      </Modal>
    </ModalOverlay>
  );
}
